import { useEffect } from "react";
import { toast } from "sonner";

/**
 * Converte itens já reconferidos pelo servidor em linhas do carrinho.
 *
 * Usado pela venda em aberto e pela recompra: os dois abrem no presente um
 * carrinho montado no passado, e o servidor devolve a mesma forma — preço e
 * estoque de hoje, mais o que estava combinado antes. Item cujo produto sumiu do
 * catálogo fica de fora do carrinho (não dá para vender o que não existe), mas
 * continua na lista de avisos, para o vendedor saber o que faltou.
 */
export function cartFromItems(items = []) {
  return items
    .filter((i) => i.product_id && i.variant_id)
    .map((i) => ({
      key: `${i.product_id}:${i.variant_id}`,
      product_id: i.product_id,
      variant_id: i.variant_id,
      name: i.name,
      // Marca vem revalidada junto do preço e do saldo (CartRevalidationService).
      // Ausente em carrinho antigo, e a linha do carrinho a omite sem quebrar.
      brand: i.brand ?? null,
      variant_label: i.variant_label,
      price: i.price,
      qty: i.qty,
    }));
}

/**
 * Recompra vinda do CRM ("refazer esta compra").
 *
 * O carrinho chega pelo estado da rota — e não por sessionStorage — porque é de
 * uso imediato: não deve sobreviver a um F5 nem vazar para outra aba aberta no
 * mesmo balcão. `replaceState` no fim limpa o estado justamente para o
 * recarregar não remontar o carrinho por cima do que o vendedor já mexeu.
 */
export function useRepeatPurchase(location, { setCart, setCustomer, setWarnings, onLoaded }) {
  useEffect(() => {
    const repeat = location.state?.repeat;
    const itens = cartFromItems(repeat?.items);
    if (!itens.length) return;

    setCart(itens);
    if (repeat.customer?.id) setCustomer(repeat.customer);
    setWarnings(repeat.items);
    onLoaded?.();
    window.history.replaceState({}, "");
    toast.success("Compra anterior carregada. Confira o que mudou antes de fechar.");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
